exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3V7v3{margin-bottom:20px}._1vPmS,._3V7v3{display:-webkit-box;display:-ms-flexbox;display:flex}._1vPmS{min-width:38px;height:38px;border:1px solid rgba(0,0,0,.15);border-radius:2px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._1vPmS:not(:last-child){margin-right:4px}._1X7ut{background-color:#ffc107}.ueLIa{color:rgba(0,0,0,.6)}", ""]);

// exports
exports.locals = {
	"root": "_3V7v3",
	"item": "_1vPmS",
	"selected": "_1X7ut",
	"disabled": "ueLIa"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/UI/RectanglesOptions/RectanglesOptions.css
// module id = 3176
// module chunks = 21